"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var MissingResourcesIcon_1 = __importDefault(require("../../../Icons/Notifications/MissingResourcesIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "WORLDS access at risk in 24hs.",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "Rectify now"),
            ' ',
            "to percent disruption.")); },
        title: 'Missing resources'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El acceso a tus Mundos sera restringido en 24 horas.",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "Rectifique ahora"),
            ' ',
            "para evitar interrupciones.")); },
        title: 'Faltan recursos'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u4E16\u754C\u63A5\u5165\u5728 24 \u5C0F\u65F6\u5185\u9762\u4E34\u98CE\u9669.",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u7ACB\u5373\u7EA0\u6B63"),
            "\uFF0C\u4EE5\u51CF\u5C11\u4E2D\u65AD")); },
        title: '缺失的资源'
    }
};
var WorldsMissingResourcesNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(MissingResourcesIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.url))));
};
exports.default = WorldsMissingResourcesNotification;
